import  { useEffect, useState } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import { Chart } from "react-google-charts"; // Для діаграми
import { exportToExcel } from "../../components/ExportToExcel.js";
import "../../styles/App.css";

const RatingReportsPage = () => {
  const [ratings, setRatings] = useState([]);
  const [filteredRatings, setFilteredRatings] = useState([]);
  const [dateFilter, setDateFilter] = useState({ from: "", to: "" });
  const [searchName, setSearchName] = useState("");
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    fetch(`${API}/api/report/rating`, {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => res.json())
      .then((data) => {
        setRatings(data.ratings);
        setFilteredRatings(data.ratings);
      })
      .catch((err) => console.error("Помилка отримання звітності:", err));
  }, []);

  useEffect(() => {
    let filtered = ratings;

    // Фільтр за датою
    if (dateFilter.from) {
      filtered = filtered.filter(
        (rating) => new Date(rating.created_at) >= new Date(dateFilter.from)
      );
    }
    if (dateFilter.to) {
      filtered = filtered.filter(
        (rating) => new Date(rating.created_at) <= new Date(dateFilter.to)
      );
    }

    // Фільтр за ПІБ
    if (searchName.trim() !== "") {
      filtered = filtered.filter((rating) =>
        rating.student_name.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    setFilteredRatings(filtered);
  }, [dateFilter, searchName, ratings]);

  // Формування даних для діаграми
  const chartData = [
    ["Студент", "Бали"],
    ...filteredRatings.reduce((acc, rating) => {
      const student = acc.find((item) => item[0] === rating.student_name);
      if (student) {
        student[1] += rating.points;
      } else {
        acc.push([rating.student_name, rating.points]);
      }
      return acc;
    }, []),
  ];

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const handleSort = (field) => {
    const newOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newOrder);
  };

  const sortedRatings = [...filteredRatings].sort((a, b) => {
    if (!sortField) return 0;
    if (a[sortField] < b[sortField]) return sortOrder === "asc" ? -1 : 1;
    if (a[sortField] > b[sortField]) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });


  return (
    <div className="page-container">
      <div className="header-content">
        <input
          type="text"
          id="search-name"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          placeholder="Пошук за ПІБ"
          className="header-content-input-report "
        />

        <div className="header-content-date">
          <label htmlFor="from-date">З</label>
          <input
            className="header-content-select"
            type="date"
            id="from-date"
            value={dateFilter.from}
            onChange={(e) =>
              setDateFilter((prev) => ({ ...prev, from: e.target.value }))
            }
          />
          <label htmlFor="to-date">до</label>
          <input
            className="header-content-select"
            type="date"
            id="to-date"
            value={dateFilter.to}
            onChange={(e) =>
              setDateFilter((prev) => ({ ...prev, to: e.target.value }))
            }
          />
        </div>
        <a
          href="#"
          onClick={() =>
            exportToExcel(
              filteredRatings,
              "Рейтинг студентів",
              "Звіт_рейтинг_студентів.xlsx",
              (rating) => ({
                ПІБ: rating.student_name,
                Дата: rating.created_at,
                Бали: rating.points,
                Опис: rating.description || "—",
                Файл: rating.file_url || "—",
              })
            )
          }
          className="propese-button"
        >
          Експортувати в Excel
        </a>
      </div>

      <div className="table-container">
        <h1 className="text-header">Таблиця рейтингу</h1>
        <table className="table">
          <thead>
            <tr>
              <th className="table-header">#</th>
              <th
                className="table-header"
                onClick={() => handleSort("created_at")}
              >
                Дата{" "}
                {sortField === "created_at"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th className="table-header" onClick={() => handleSort("points")}>
                Бали{" "}
                {sortField === "points"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("description")}
              >
                Опис{" "}
                {sortField === "description"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("student_name")}
              >
                Студент{" "}
                {sortField === "student_name"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("file_url")}
              >
                Файл{" "}
                {sortField === "file_url"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedRatings.map((rating, index) => (
              <tr key={rating.id}>
                <td className="table-content">{index + 1}</td>
                <td className="table-content">{rating.created_at}</td>
                <td className="table-content">{rating.points}</td>
                <td className="table-content">{rating.description || "—"}</td>
                <td className="table-content">{rating.student_name}</td>
                <td className="table-content">
                  {rating.file_url ? (
                    <a
                      href={rating.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Переглянути файл
                    </a>
                  ) : (
                    "—"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="chart-container">
        <h1 className="text-header">Рейтинг студентів</h1>
        <Chart
          chartType="Bar"
          width="100%"
          height="400px"
          data={chartData}
          options={{
            title: "Бали студентів",
            legend: { position: "none" },
          }}
        />
      </div>
    </div>
  );
};

export default RatingReportsPage;
